module.exports = __webpack_public_path__ + "static/media/icon-minimize.f469c460.svg";